import { Link } from "react-router-dom";
import { Scale } from "lucide-react";
import { scrollToId } from "@/pages/LandingPage";

export default function Footer() {
  return (
    <footer className="bg-[#0B192C] border-t border-white/10 py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10 mb-12">
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 rounded-lg bg-sky-400 text-[#0B192C] flex items-center justify-center">
              <Scale size={18} strokeWidth={2.2} />
            </span>
            <span className="leading-none">
              <span className="font-display font-extrabold text-lg tracking-tight text-white block">John Jones</span>
              <span className="font-mono-accent text-[10px] uppercase tracking-[0.22em] text-sky-400 block mt-1">Independent Associate · LegalShield</span>
            </span>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3 text-sm">
            {[["How it works", "#how-it-works"], ["For families", "#families"], ["For business", "#business"], ["Partner up", "#partner"], ["Get the details", "#get-started"]].map(([label, href]) => (
              <button key={href} data-testid={`footer-link-${href.slice(1)}`} onClick={() => scrollToId(href)} className="text-slate-400 hover:text-white transition-colors duration-200">
                {label}
              </button>
            ))}
            <Link data-testid="footer-admin-link" to="/admin" className="text-slate-500 hover:text-white transition-colors duration-200">Associate login</Link>
          </nav>
        </div>
        <div className="border-t border-white/10 pt-8 space-y-4">
          <p className="text-xs text-slate-500 leading-relaxed max-w-3xl" data-testid="footer-disclaimer">
            This page is operated by John Jones, an independent associate of LegalShield — it is not
            LegalShield's official website, and I am not a LegalShield employee. Nothing here is legal
            advice, and no specific outcome is promised or guaranteed. Plan features described are
            general summaries only; complete terms, coverage, pricing, and exclusions are in the
            official plan documents you receive before enrolling. Enrollment is completed through my
            official associate enrollment page.
          </p>
          <p className="text-xs text-slate-600">© {new Date().getFullYear()} EquiLegal Independent Associate. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
